module.exports = __webpack_public_path__ + "img/active-employees.eae72651.png";